export const SlideHook = {
  mounted() {
    this.el.addEventListener("storybook:resize", () => {
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 200);
    });
  },
};
